export default __webpack_public_path__ + "3cc883c50b92ccef73d301ce020aa282.png";